import { BrowserRouter, Route, Routes } from "react-router-dom";
import Routing from "./Routing";
import MetaDecorator from "./components/MetaDecorator/MetaDecorator";
import { useEffect } from "react";

// Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";

// Import AOS styles
import AOS from "aos";
import "aos/dist/aos.css";

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1500,
    });
  }, []);
  return (
    <>
      <MetaDecorator
        metaTitle="Everest | Taste Masters"
        metaDesc="An exclusive program made for the passionate foodie in you"
        canonicalLink={window.location}
      />

      <BrowserRouter>
        {/* <ScrollToTop /> */}
        <Routes>
          <Route path="*" element={<Routing />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
